/**
 * Promotions Utility Functions
 * Pure functions for promotion data manipulation
 */

import type { Promotion } from '../resources/checkout';

// Re-export types from resources for convenience
export type { Promotion };

export class PromotionsUtils {
    /**
     * Check if promotion is valid
     */
    static isValidPromotion(promotion: Promotion): boolean {
        return !!(promotion.id && promotion.name);
    }

    /**
     * Get promotion type
     */
    static getPromotionType(promotion: Promotion): string {
        return promotion.type || 'unknown';
    }

    /**
     * Check if promotion has rules
     */
    static hasRules(promotion: Promotion): boolean {
        return !!(promotion.rules && promotion.rules.length > 0);
    }

    /**
     * Check if promotion has actions
     */
    static hasActions(promotion: Promotion): boolean {
        return !!(promotion.actions && promotion.actions.length > 0);
    }
}
